export default __webpack_public_path__ + "static/media/sbe-login-cover.c0cb8ab1.png";